import { useMemo, type ReactNode } from "react";
import { BannerProvider } from "./context/BannerContext";
import { CartProvider } from "./services/menu/CartContext.tsx";
import { FavoriteProvider } from "./services/menu/FavoriteContext";
import { LoginModalProvider } from "./context/LoginModalContext";
import { useLoginModal } from "./context/useLoginModal";
import Login from "./pages/auth/Login";
import { MaintenanceProvider, useMaintenance } from "./context/MaintenanceContext";
import MaintenanceScreen from "./components/maintenance/MaintenanceScreen";

// CartContext ichidan (masalan, login qilmagan holatda savatga
// mahsulot qo'shishga urinishda) ochiladigan global login oynasi
const GlobalLoginModal = () => {
  const { isLoginOpen, closeLoginModal } = useLoginModal();
  return <Login isOpen={isLoginOpen} onClose={closeLoginModal} />;
};

const MaintenanceWrapper: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { isMaintenance } = useMaintenance();
  
  if (isMaintenance) {
    return <MaintenanceScreen />;
  }
  
  return <>{children}</>;
};

export const AppProviders: React.FC<{ children: ReactNode }> = ({ children }) => {
  const memoizedChildren = useMemo(() => children, [children]);

  return (
    <MaintenanceProvider>
      <MaintenanceWrapper>
        <LoginModalProvider>
          <CartProvider>
            <BannerProvider>
              <FavoriteProvider>
                {memoizedChildren}
              </FavoriteProvider>
            </BannerProvider>
            <GlobalLoginModal />
          </CartProvider>
        </LoginModalProvider>
      </MaintenanceWrapper>
    </MaintenanceProvider>
  );
};
// Triggering HMR update